import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import ServicesView from './ServicesView';
import GoogleAnalytics from '@/presentation/hooks/useGoogleAnalytics';
import constants from './constants';

const ServicesViewController = () => {
  const history = useHistory();

  const handlerRedirect = (route: any) => {
    GoogleAnalytics.writeLog(
      `GoTo-${(route as string).replaceAll('servicios/', '')}`,
      'redirect',
      route
    );
    history.push(`/${route}`);
  };

  useEffect(() => {
    GoogleAnalytics.writeLog('Menu-Servicios', 'Menu');
  }, []);

  return (
    <ServicesView
      handlerRedirect={handlerRedirect}
      servicesSections={constants.servicesSections}
      sectionHeader={constants.sectionHeader}
    />
  );
};

export default ServicesViewController;
